import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete';
import type { AdDurationOption, MaxAdDurationStatePayload } from '@openx/types/targeting/video';
import type { HTMLAttributes, JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useValidation } from '../hooks/useValidation';
import { minLengthOptions } from '../utils/constants';

type Props = {
  renderOption: (props: HTMLAttributes<HTMLLIElement>, option: AdDurationOption) => ReactNode;
  onChange: (typeParams: Partial<MaxAdDurationStatePayload> | null) => void;
  value: MaxAdDurationStatePayload | null;
};

export const ExactItem = ({ renderOption, onChange, value }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { validation } = useValidation(value);

  return (
    <Grid size={19}>
      <AutoComplete<AdDurationOption, false, boolean, boolean>
        options={minLengthOptions}
        disableClearable
        onChange={(_e, newValue) => onChange({ start: newValue, end: newValue })}
        onInputChange={(_e, newValue) => onChange({ start: newValue, end: newValue })}
        value={value?.start ?? null}
        inputValue={value?.start ?? ''}
        fullWidth
        textFieldProps={{
          placeholder: '1',
          slotProps: {
            input: {
              endAdornment: <Typography color="textSecondary">{t('sec')}</Typography>,
            },
          },
          required: true,
          error: validation.start.error,
          helperText: validation.start.helperText,
        }}
        renderOption={renderOption}
        freeSolo
        forcePopupIcon
        data-test="exact-item-input"
      />
    </Grid>
  );
};
